var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeqiang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 652",
    d: "M8.05435 1.78201L7.25244 2.31662V10.1486L14.1756 14.1849L14.8973 13.7572V5.71139L8.05435 1.78201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 651",
    d: "M15.2919 5.37635L8.70921 1.4375L7.30591 2.2899L14.1623 6.27273V14.1983L15.6157 13.254L15.2919 5.37635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 650",
    d: "M8.65532 1.4375L7.25244 2.31661V10.1486L14.1756 14.1849L15.4269 13.4159V5.34937L8.65532 1.4375Z",
    stroke: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 4769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4767_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4766_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 652_2",
    d: "M2.24893 3.89624L1.44702 4.43085V12.2629L8.3702 16.2992L9.09192 15.8715V7.82561L2.24893 3.89624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 651_2",
    d: "M9.48652 7.49055L2.90379 3.5517L1.50049 4.4041L8.35684 8.38693V16.3125L9.81026 15.3682L9.48652 7.49055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 650_2",
    d: "M2.8499 3.5517L1.44702 4.43081V12.2628L8.3702 16.2991L9.62148 15.5301V7.46357L2.8499 3.5517Z",
    stroke: "black"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeqiang);
export default __webpack_public_path__ + "static/media/geqiang.b12c9aa040cb3c45d2fd982bdb37ab18.svg";
export { ForwardRef as ReactComponent };